import { useState } from "react";
import { motion } from "framer-motion";
import { Download } from "lucide-react";
import axios from "axios";
import { API } from "../app/constants";

export const SocialSharePanel = ({ portraitId, onShareBonus }) => {
  const [shareCardLoading, setShareCardLoading] = useState(false);

  const handleShare = async (platform) => {
    const shareUrl = `https://starframeai.com?ref=${portraitId}`;
    const shareText = "Just transformed my portrait with StarFrame AI! The results are incredible.";
    let url = "";
    switch (platform) {
      case "twitter": url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`; break;
      case "linkedin": url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`; break;
      case "facebook": url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`; break;
      case "whatsapp": url = `https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`; break;
      case "viber": url = `viber://forward?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`; break;
      case "telegram": url = `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`; break;
      default: return;
    }
    window.open(url, "_blank", "width=600,height=400");
    if (onShareBonus) onShareBonus(platform);
  };

  const handleDownloadShareCard = async () => {
    setShareCardLoading(true);
    try {
      const res = await axios.get(`${API}/portraits/share-card/${portraitId}`);
      const link = document.createElement("a");
      link.href = `data:image/png;base64,${res.data.share_card_base64}`;
      link.download = `starframe-${res.data.style || "portrait"}.png`;
      link.click();
    } catch (err) { console.error("Share card error:", err); }
    setShareCardLoading(false);
  };

  return (
    <motion.div data-testid="social-share-panel" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="bg-white/5 border border-white/10 rounded-xl p-3">
      <p className="text-white/60 text-xs mb-2 font-medium">Share on social media & earn credits</p>
      <div className="grid grid-cols-3 gap-2">
        <button data-testid="share-twitter" onClick={() => handleShare("twitter")} className="bg-[#1DA1F2]/20 hover:bg-[#1DA1F2]/30 text-[#1DA1F2] py-2 rounded-lg text-xs font-medium transition-colors">Twitter / X</button>
        <button data-testid="share-linkedin" onClick={() => handleShare("linkedin")} className="bg-[#0A66C2]/20 hover:bg-[#0A66C2]/30 text-[#0A66C2] py-2 rounded-lg text-xs font-medium transition-colors">LinkedIn</button>
        <button data-testid="share-facebook" onClick={() => handleShare("facebook")} className="bg-[#1877F2]/20 hover:bg-[#1877F2]/30 text-[#1877F2] py-2 rounded-lg text-xs font-medium transition-colors">Facebook</button>
        <button data-testid="share-whatsapp" onClick={() => handleShare("whatsapp")} className="bg-[#25D366]/20 hover:bg-[#25D366]/30 text-[#25D366] py-2 rounded-lg text-xs font-medium transition-colors">WhatsApp</button>
        <button data-testid="share-viber" onClick={() => handleShare("viber")} className="bg-[#7360F2]/20 hover:bg-[#7360F2]/30 text-[#7360F2] py-2 rounded-lg text-xs font-medium transition-colors">Viber</button>
        <button data-testid="share-telegram" onClick={() => handleShare("telegram")} className="bg-[#26A5E4]/20 hover:bg-[#26A5E4]/30 text-[#26A5E4] py-2 rounded-lg text-xs font-medium transition-colors">Telegram</button>
      </div>
      <button data-testid="share-download-card" onClick={handleDownloadShareCard} disabled={shareCardLoading}
        className="w-full mt-2 bg-gold/10 hover:bg-gold/20 text-gold py-1.5 rounded-lg text-xs font-medium transition-colors flex items-center justify-center gap-1">
        {shareCardLoading ? "Generating..." : <><Download className="w-3 h-3" /> Download Share Card</>}
      </button>
    </motion.div>
  );
};
